"use strict";

var _objectWithoutProperties = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _excluded = ["style", "poster", "muted"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _shakaPlayer = _interopRequireDefault(require("shaka-player"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Video = /*#__PURE__*/function (_react$default$PureCo) {
  function Video(props) {
    var _this;
    _classCallCheck(this, Video);
    _this = _callSuper(this, Video, [props]);
    _defineProperty(_this, "state", {
      playing: false
    });
    _this.videoRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  _inherits(Video, _react$default$PureCo);
  return _createClass(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Install built-in polyfills to patch browser incompatibilities.
      _shakaPlayer.default.polyfill.installAll();
      this.initPlayer();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      console.log("video ".concat(this.props.src, " unmounting..."));
      if (this.interval) clearInterval(this.interval);
      if (this.player) this.player.destroy();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.src !== this.props.src) {
        this.initPlayer();
      }
    }
  }, {
    key: "checkIsPlaying",
    value: function checkIsPlaying() {
      if (this.state.playing) {
        clearInterval(this.interval);
        return;
      }
      var src = this.props.src;
      if (this.player) {
        var stats = this.player.getStats();
        console.log("player stats for video ".concat(src), stats);
        if (stats.playTime > 0) {
          this.setState({
            playing: true
          });
        } else {
          var videoElement = this.videoRef.current;
          console.log("force playing video ".concat(src, "..."));
          videoElement.play();
        }
      }
    }
  }, {
    key: "initPlayer",
    value: function initPlayer() {
      var _this2 = this;
      // Check to see if the browser supports the basic APIs Shaka needs.
      if (!_shakaPlayer.default.Player.isBrowserSupported()) {
        console.error('Browser not supported!');
        return;
      }
      var src = this.props.src;
      var videoElement = this.videoRef.current;
      this.player = new _shakaPlayer.default.Player(videoElement);
      this.player.configure({
        streaming: {
          bufferingGoal: undefined,
          rebufferingGoal: 0
        }
      });
      this.interval = setInterval(function () {
        return _this2.checkIsPlaying();
      }, 200);

      // Listen for error events.
      this.player.addEventListener('error', this.onErrorEvent);

      // Try to load a manifest.
      // This is an asynchronous process.
      this.player.load(src).then(function () {
        // This runs if the asynchronous load is successful.
        console.log("The video ".concat(src, " has now been loaded!"));
        videoElement.play();
      }).catch(this.onError); // onError is executed if the asynchronous load fails.
    }
  }, {
    key: "onErrorEvent",
    value: function onErrorEvent(event) {
      // Extract the shaka.util.Error object from the event.
      this.onError(event.detail);
    }
  }, {
    key: "onError",
    value: function onError(error) {
      // Log the error.
      console.error('Error code', error.code, 'object', error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        style = _this$props.style,
        poster = _this$props.poster,
        muted = _this$props.muted,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement("video", _extends({
        style: style,
        playsInline: true,
        loop: true,
        autoPlay: true,
        ref: this.videoRef
      }, muted ? {
        muted: true
      } : {}, {
        poster: poster ? poster : "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      }, otherProps));
    }
  }]);
}(_react.default.PureComponent);
var _default = exports.default = Video;